export default __webpack_public_path__ + "static/media/mad-ape-006.cb09a412.svg";